export const COLLECTIONS_ACTIONS = {
  REQUESTED: 'collections/requested',
  SUCCEEDED: 'collections/succeeded',
  FAILED: 'collections/failed',
};

export const REMOVE_COLLECTION_ACTIONS = {
  REQUESTED: 'collections/remove/requested',
  SUCCEEDED: 'collections/remove/succeeded',
  FAILED: 'collections/remove/failed',
};

export const CREATE_COLLECTION_ACTIONS = {
  REQUESTED: 'collections/create/requested',
  SUCCEEDED: 'collections/create/succeeded',
  FAILED: 'collections/create/failed',
};

export const EDIT_COLLECTION_ACTIONS = {
  REQUESTED: 'collections/edit/requested',
  SUCCEEDED: 'collections/edit/succeeded',
  FAILED: 'collections/edit/failed',
};

export const SET_EDIT_COLLECTION_ACTIONS = {
  SELECT: 'collections/set/edit/select',
  REMOVE: 'collections/set/edit/remove',
};

export interface CollectionsRequested {
  type: string;
}

export const collectionsRequested = () => ({
  type: COLLECTIONS_ACTIONS.REQUESTED,
});

export interface CollectionsSucceeded {
  type: string;
  payload: { collections: any[] };
}

export const collectionsSucceeded = (collections: any[]) => ({
  type: COLLECTIONS_ACTIONS.SUCCEEDED,
  payload: { collections },
});

export interface CollectionsFailed {
  error: any;
  type: string;
}

export const collectionsFailed = (error: any) => ({
  error,
  type: COLLECTIONS_ACTIONS.FAILED,
});

export interface RemoveCollectionRequested {
  type: string;
  payload: { collectionId: string };
}

export const removeCollectionRequested = (collectionId: string) => ({
  type: REMOVE_COLLECTION_ACTIONS.REQUESTED,
  payload: { collectionId },
});

export interface RemoveCollectionSucceeded {
  type: string;
  payload: { collectionId: string };
}

export const removeCollectionSucceeded = (collectionId: string) => ({
  type: REMOVE_COLLECTION_ACTIONS.SUCCEEDED,
  payload: { collectionId },
});

export const removeCollectionFailed = (error: any) => ({
  error,
  type: COLLECTIONS_ACTIONS.FAILED,
});

export interface CreateCollectionRequested {
  type: string;
  payload: { collection: any };
}

export const createCollectionRequested = (collection: any, file: any) => ({
  type: CREATE_COLLECTION_ACTIONS.REQUESTED,
  payload: { collection, file },
});

export interface CreateCollectionSucceeded {
  type: string;
  payload: { collection: any };
}

export const createCollectionSucceeded = (collection: any) => ({
  type: CREATE_COLLECTION_ACTIONS.SUCCEEDED,
  payload: { collection },
});

export const createCollectionFailed = (error: any) => ({
  error,
  type: CREATE_COLLECTION_ACTIONS.FAILED,
});

export interface EditCollectionRequested {
  type: string;
  payload: { collection: any };
}

export const editCollectionRequested = (collection: any, file: any) => ({
  type: EDIT_COLLECTION_ACTIONS.REQUESTED,
  payload: { collection, file },
});

export interface EditCollectionSucceeded {
  type: string;
  payload: { collection: any };
}

export const editCollectionSucceeded = (collection: any) => ({
  type: EDIT_COLLECTION_ACTIONS.SUCCEEDED,
  payload: { collection },
});

export const editCollectionFailed = (error: any) => ({
  error,
  type: EDIT_COLLECTION_ACTIONS.FAILED,
});

export const setEditCollection = (collection: any) => ({
  type: SET_EDIT_COLLECTION_ACTIONS.SELECT,
  payload: { collection },
});

export const removeEditCollection = () => ({
  type: SET_EDIT_COLLECTION_ACTIONS.REMOVE,
});

export type CollectionsAction =
  | CollectionsRequested
  | CollectionsFailed
  | CollectionsSucceeded
  | CollectionsSucceeded
  | RemoveCollectionRequested
  | RemoveCollectionSucceeded
  | CreateCollectionRequested
  | CreateCollectionSucceeded
  | EditCollectionRequested
  | EditCollectionSucceeded;



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/actions.ts